import React, { Fragment, useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

// import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import { Grid, Typography, FormGroup, Tooltip, Collapse } from '@mui/material';

import ThumbDownAltTwoToneIcon from '@mui/icons-material/ThumbDownAltTwoTone';

import HostDashboardEventCard from '../events/HostDashboardEventCard';
import AnimatedEventCardSlot from './AnimatedEventCardSlot';

import Button from '../layout/SvgButton';

const CanceledHostEvents = ({
    hostMe,
    myHostEvents,
    recentlyCanceledIds,
    onAnimationComplete,
}) => {
    const [showCanceledEvents, setShowCanceledEvents] = useState(false);

    useEffect(() => {
        if (myHostEvents && myHostEvents.length > 0) {
            const unReviewedEvents = myHostEvents.forEach((myHostEvent) => {
                if (
                    myHostEvents.filter(
                        (myEvent) =>
                            myEvent.confirmedHost &&
                            myEvent.status === 'CANCELED'
                    ).length > 0
                ) {
                    setShowCanceledEvents(true);
                }
            });
        }
    }, [myHostEvents]);

    // When a cancellation begins (before redux has caught up), preemptively
    // open the canceled section so the incoming card has a place to animate
    // into.
    useEffect(() => {
        if (
            Array.isArray(recentlyCanceledIds) &&
            recentlyCanceledIds.length > 0
        ) {
            setShowCanceledEvents(true);
        }
    }, [recentlyCanceledIds]);

    return (
        <>
            {myHostEvents &&
                myHostEvents.length > 0 &&
                myHostEvents.filter(
                    (myEvent) =>
                        myEvent.confirmedHost && myEvent.status === 'CANCELED'
                ).length > 0 && (
                    <>
                        <Typography
                            onClick={() =>
                                setShowCanceledEvents(!showCanceledEvents)
                            }
                            sx={{
                                color: 'var(--link-color)',
                                cursor: 'pointer',
                                margin: showCanceledEvents
                                    ? '16px 16px 0px 16px'
                                    : '16px 16px 16px 16px',
                                textAlign: 'center',
                                // transition: 'margin 0.3s ease-in-out',
                            }}
                        >
                            {showCanceledEvents
                                ? 'Hide Canceled Events'
                                : 'Show Canceled Events'}
                        </Typography>
                        <Collapse in={showCanceledEvents} timeout={300}>
                            <Grid
                                container
                                direction="column"
                                sx={{
                                    marginBottom: '20px',
                                    marginTop: showCanceledEvents
                                        ? '0px'
                                        : '-20px',
                                    transition: 'margin 0.3s ease-in-out',
                                }}
                            >
                                <Grid item>
                                    <Typography component="h2">
                                        {myHostEvents.filter(
                                            (myEvent) =>
                                                myEvent.confirmedHost &&
                                                myEvent.status === 'CANCELED'
                                        ).length > 1
                                            ? `These ${
                                                  myHostEvents.filter(
                                                      (myEvent) =>
                                                          myEvent.confirmedHost &&
                                                          myEvent.status ===
                                                              'CANCELED'
                                                  ).length
                                              } concerts got canceled`
                                            : `This concert got canceled`}
                                        :
                                    </Typography>
                                </Grid>
                                {/* {bookingWhenWhere && bookingWhenWhere.length > 0 && bookingWhenWhere[0].when ? //check to be sure there's a valid first entry */}
                                <Grid
                                    container
                                    className="whenBooking"
                                    direction="row"
                                    justifyContent="center"
                                    alignItems="center"
                                    spacing={2}
                                    sx={{
                                        margin: '0px auto 16px',
                                        width: '100%',
                                    }}
                                >
                                    {myHostEvents
                                        .filter(
                                            (myEvent) =>
                                                myEvent.confirmedHost &&
                                                myEvent.status === 'CANCELED'
                                        )
                                        .sort((a, b) => {
                                            const aTime = new Date(
                                                a?.bookingWhen || 0
                                            ).getTime();
                                            const bTime = new Date(
                                                b?.bookingWhen || 0
                                            ).getTime();
                                            return bTime - aTime; // most recent first
                                        })
                                        .map(
                                            (thisEvent, idx) =>
                                                thisEvent.bookingWhen &&
                                                thisEvent.bookingWhere && (
                                                    <AnimatedEventCardSlot
                                                        key={
                                                            (thisEvent &&
                                                                thisEvent._id) ||
                                                            idx
                                                        }
                                                        eventId={
                                                            thisEvent._id
                                                        }
                                                        isArriving={
                                                            Array.isArray(
                                                                recentlyCanceledIds
                                                            ) &&
                                                            recentlyCanceledIds.includes(
                                                                thisEvent._id
                                                            )
                                                        }
                                                        onAnimationComplete={
                                                            onAnimationComplete
                                                        }
                                                    >
                                                        <HostDashboardEventCard
                                                            thisEvent={
                                                                thisEvent
                                                            }
                                                        />
                                                    </AnimatedEventCardSlot>
                                                )
                                        )}
                                </Grid>
                            </Grid>
                        </Collapse>
                    </>
                )}
        </>
    );
};

CanceledHostEvents.propTypes = {
    host: PropTypes.object,
    myHostEvents: PropTypes.array,
    recentlyCanceledIds: PropTypes.array,
    onAnimationComplete: PropTypes.func,
    // iConfirmed: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    host: state.host,
    myHostEvents: state.event.myHostEvents,
});

export default connect(mapStateToProps, {})(CanceledHostEvents);
